import { SortDirectionEnum } from '../enums';
import { ApiSortOrderType, SortDirectionType } from '../types';

export function isApiSortDirection(direction: SortDirectionType): direction is ApiSortOrderType {
  return direction !== SortDirectionEnum.None;
}
